// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Belluga.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Clother-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Clother-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Clother-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Clother-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Clother-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/Clother-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Clother-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/Clother-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/Clother-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/Silvana-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/Silvana-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/Silvana-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/Silvana-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/OpenSans-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/OpenSans-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/OpenSans-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/OpenSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/OpenSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/OpenSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/OpenSans-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/OpenSans-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/OpenSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/OpenSans-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/OpenSans-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/OpenSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/OpenSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/OpenSans-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/OpenSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/OpenSans-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../fonts/OpenSans-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../fonts/OpenSans-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Belluga';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Clother';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Clother';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Clother';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}


@font-face {
    font-family: 'Silvana';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Silvana';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'OpenSans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('ttf');
    font-weight: 300;
    font-display: swap;
}

@font-face {
    font-family: 'OpenSans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('ttf');
    font-weight: 400;
    font-display: swap;
}
@font-face {
    font-family: 'OpenSans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('ttf');
    font-weight: 500;
    font-display: swap;
}

@font-face {
    font-family: 'OpenSans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format('ttf');
    font-weight: 600;
    font-display: swap;
}

@font-face {
    font-family: 'OpenSans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format('ttf');
    font-weight: 700;
    font-display: swap;
}

@font-face {
    font-family: 'OpenSans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format('ttf');
    font-weight: 800;
    font-display: swap;
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,4DAAkD;IAClD,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;;8DAEmD;IACnD,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;;8DAEsD;IACtD,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;;8DAEoD;IACpD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,sBAAsB;IACtB;2DACiD;IACjD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;2DACuD;IACvD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB;;0DAEgD;IAChD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB;;0DAEkD;IAClD,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB;;0DAEiD;IACjD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB;;0DAEmD;IACnD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB;;0DAE+C;IAC/C,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB;;0DAEoD;IACpD,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":["@font-face {\n    font-family: 'Belluga';\n    src: url('../fonts/Belluga.woff2') format('woff2');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Clother';\n    src: url('../fonts/Clother-Bold.woff2') format('woff2'),\n    url('../fonts/Clother-Bold.woff') format('woff'),\n    url('../fonts/Clother-Bold.ttf') format('truetype');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Clother';\n    src: url('../fonts/Clother-Regular.woff2') format('woff2'),\n    url('../fonts/Clother-Regular.woff') format('woff'),\n    url('../fonts/Clother-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Clother';\n    src: url('../fonts/Clother-Light.woff2') format('woff2'),\n    url('../fonts/Clother-Light.woff') format('woff'),\n    url('../fonts/Clother-Light.ttf') format('truetype');\n    font-weight: 300;\n    font-style: normal;\n    font-display: swap;\n}\n\n\n@font-face {\n    font-family: 'Silvana';\n    src: url('../fonts/Silvana-Light.woff2') format('woff2'),\n    url('../fonts/Silvana-Light.woff') format('woff');\n    font-weight: 300;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Silvana';\n    src: url('../fonts/Silvana-LightItalic.woff2') format('woff2'),\n    url('../fonts/Silvana-LightItalic.woff') format('woff');\n    font-weight: 300;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'OpenSans';\n    src: url('../fonts/OpenSans-Light.woff2') format('woff2'),\n    url('../fonts/OpenSans-Light.woff') format('woff'),\n    url('../fonts/OpenSans-Light.ttf') format('ttf');\n    font-weight: 300;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'OpenSans';\n    src: url('../fonts/OpenSans-Regular.woff2') format('woff2'),\n    url('../fonts/OpenSans-Regular.woff') format('woff'),\n    url('../fonts/OpenSans-Regular.ttf') format('ttf');\n    font-weight: 400;\n    font-display: swap;\n}\n@font-face {\n    font-family: 'OpenSans';\n    src: url('../fonts/OpenSans-Medium.woff2') format('woff2'),\n    url('../fonts/OpenSans-Medium.woff') format('woff'),\n    url('../fonts/OpenSans-Medium.ttf') format('ttf');\n    font-weight: 500;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'OpenSans';\n    src: url('../fonts/OpenSans-SemiBold.woff2') format('woff2'),\n    url('../fonts/OpenSans-SemiBold.woff') format('woff'),\n    url('../fonts/OpenSans-SemiBold.ttf') format('ttf');\n    font-weight: 600;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'OpenSans';\n    src: url('../fonts/OpenSans-Bold.woff2') format('woff2'),\n    url('../fonts/OpenSans-Bold.woff') format('woff'),\n    url('../fonts/OpenSans-Bold.ttf') format('ttf');\n    font-weight: 700;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'OpenSans';\n    src: url('../fonts/OpenSans-ExtraBold.woff2') format('woff2'),\n    url('../fonts/OpenSans-ExtraBold.woff') format('woff'),\n    url('../fonts/OpenSans-ExtraBold.ttf') format('ttf');\n    font-weight: 800;\n    font-display: swap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
